module.exports = __webpack_public_path__ + "static/media/Ellipsis45.ce19fad0.gif";